import { render, staticRenderFns } from "./_partnership.vue?vue&type=template&id=10711a0f&scoped=true&lang=pug&"
import script from "./_partnership.vue?vue&type=script&lang=js&"
export * from "./_partnership.vue?vue&type=script&lang=js&"
import style0 from "./_partnership.vue?vue&type=style&index=0&id=10711a0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10711a0f",
  null
  
)

export default component.exports